import styled from 'styled-components'
import { MessagePasswordRequestSendUnstyled } from './unstyled'

export const MessagePasswordRequestSend = styled(
  MessagePasswordRequestSendUnstyled,
)`
  position: relative;
  width: 100%;
  height: 100%;

  .wrapper {
    position: absolute;
    width: 100%;
    max-width: 420px;
    left: 0;
    right: 0;
    top: 50%;
    margin: auto;
    transform: translateY(-50%);

    p {
      margin: 35px 0;
      color: ${props => props.theme.colors.regentGray};

      span {
        color: ${props => props.theme.colors.primary};
      }
    }

    svg {
      fill: ${props => props.theme.colors.green};
      width: 30px;
      height: 30px;
      margin: 0 10px 0 0px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/Components/Message/PasswordRequestSend/index.js